<template>
<div id="siteframe">
	<!-- content -->
	<div id="content">
		<div id="_page_content">
            <div class="column_100">
	            <div id="main" min_height="400" style="; width: 100%">
                    <div>
	                    <div class="heroband" style="background: #1e2338 url(/static/images/hero-demo.png) center center no-repeat; background-size: cover;">
                            <h1>Thanks!</h1>
                        </div>
                    </div>
                    <div class="container" style="margin-top: 40px;">
                        <h2 class="callout" style="padding:28px !important; color: black !important">Your request has been received and we'll contact you ASAP. Please feel free to call us anytime at 877-387-6960.</h2>
                    </div>
                </div>
            </div>
		</div>
	</div>
</div>

</template>

<script>
	import {EventBus} from '../event-bus.js'

    export default {
        name: 'thanks',
        data () {
            return {
               
            }
        },
        mounted(){
            console.log("hai")
        },
        methods:{
            showNoty: function(){
                EventBus.$emit('noty', {type:'success',msg:'hurray!'});
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/js/components/Thanks.vue